// Утилита для воспроизведения звуковых уведомлений

let audioContext: AudioContext | null = null

// Получаем или создаём AudioContext
const getAudioContext = (): AudioContext => {
    if (!audioContext) {
        audioContext = new (window.AudioContext || (window as any).webkitAudioContext)()
    }
    return audioContext
}

// Проверяем, включён ли звук
export const isSoundEnabled = (): boolean => {
    return localStorage.getItem("notification_sound") !== "false"
}

// Включаем/выключаем звук
export const setSoundEnabled = (enabled: boolean): void => {
    localStorage.setItem("notification_sound", String(enabled))
}

// Воспроизводим звук уведомления о новом объявлении
export const playNewAdSound = (): void => {
    if (!isSoundEnabled()) return

    try {
        const ctx = getAudioContext()
        
        // Если контекст приостановлен (требование браузера), возобновляем
        if (ctx.state === "suspended") {
            ctx.resume()
        }

        const currentTime = ctx.currentTime

        // Создаём два тона для приятного звука "динь-дон"
        // Первый тон (высокий)
        const osc1 = ctx.createOscillator()
        const gain1 = ctx.createGain()
        osc1.connect(gain1)
        gain1.connect(ctx.destination)
        osc1.frequency.value = 880 // A5
        osc1.type = "sine"
        gain1.gain.setValueAtTime(0.3, currentTime)
        gain1.gain.exponentialRampToValueAtTime(0.01, currentTime + 0.3)
        osc1.start(currentTime)
        osc1.stop(currentTime + 0.3)

        // Второй тон (ещё выше) с небольшой задержкой
        const osc2 = ctx.createOscillator()
        const gain2 = ctx.createGain()
        osc2.connect(gain2)
        gain2.connect(ctx.destination)
        osc2.frequency.value = 1318.5 // E6
        osc2.type = "sine"
        gain2.gain.setValueAtTime(0, currentTime + 0.1)
        gain2.gain.linearRampToValueAtTime(0.25, currentTime + 0.15)
        gain2.gain.exponentialRampToValueAtTime(0.01, currentTime + 0.5)
        osc2.start(currentTime + 0.1)
        osc2.stop(currentTime + 0.5)

    } catch (error) {
        console.warn("Не удалось воспроизвести звук:", error)
    }
}

// Тестовый звук (для проверки в настройках)
export const playTestSound = (): void => {
    const wasEnabled = isSoundEnabled()
    // Временно включаем для теста
    if (!wasEnabled) {
        setSoundEnabled(true)
    }
    playNewAdSound()
    // Возвращаем обратно
    if (!wasEnabled) {
        setSoundEnabled(false)
    }
}
